var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.parameters, function (parameter) {
    return _c('div', [_c('parameter-input', {
      attrs: {
        "parameter": parameter,
        "parameter-group-identifier": _vm.parameterGroupIdentifier,
        "label": _vm.$t(`frontend-parameters.parameters.${_vm.parameterGroupIdentifier}.${_vm.subGroupIdentifier}.${parameter.key}.title`)
      },
      model: {
        value: _vm.internalValue[parameter.key],
        callback: function ($$v) {
          _vm.$set(_vm.internalValue, parameter.key, $$v);
        },
        expression: "internalValue[parameter.key]"
      }
    })], 1);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }